module.exports = __webpack_public_path__ + "img/RJMT_email.5cf00a4a.svg";